type AggregationOfProfitLossProps = {

}

export const AggregationOfProfitLoss = (props: AggregationOfProfitLossProps) => {
  return <></>
}